<div class="tab-wrapper" [ngClass]="{ mobile: (isMobile$ | async) }">
  <div class="wrapper">
    <div class="statistics-info">
      <div *ngIf="!isAccessTokenPage" class="statistics-info__block stat dashboard-card d-card-padding" [class.wm-loading]="!initStatisticsLoaded">
        <ng-container *ngIf="initStatisticsLoaded">
          <h3 class="stat__title bold mb-1">
            {{ 'WM_TECH_POOL.STATISTICS.ACCOUNT_INFO' | translate }}
          </h3>

          <div class="stat__total-block total total__first">
            <div class="total">
              <p class="opacity-text">
                <span>{{ initStatistics?.lastDayIncome }}</span> BTC
              </p>
              <div class="total-gradient"></div>
              <p class="opacity-text mat-small">
                {{ 'WM_TECH_POOL.STATISTICS.LAST_DAY_INCOME' | translate }}
              </p>
            </div>

            <div class="total">
              <p class="opacity-text">
                <span>{{ initStatistics?.last24hoursIncome }}</span> BTC
              </p>
              <div class="total-gradient"></div>
              <p class="opacity-text mat-small">
                {{ 'WM_TECH_POOL.STATISTICS.LAST_24H_INCOME' | translate }}
              </p>
            </div>
          </div>

          <div class="stat__total-block total">
            <div class="total">
              <p class="opacity-text">
                <span>{{ selectedFarm?.totalProfit }}</span> BTC
              </p>
              <div class="total-gradient"></div>
              <p class="opacity-text mat-small">
                {{ 'WM_TECH_POOL.STATISTICS.TOTAL_EARNINGS' | translate }}
              </p>
            </div>

            <div class="total">
              <p class="opacity-text">
                <span>{{ selectedFarm?.balance }}</span> BTC
              </p>
              <div class="total-gradient"></div>
              <p class="opacity-text mat-small">
                {{ 'WM_TECH_POOL.STATISTICS.ACCOUNT_BALANCE' | translate }}
              </p>
            </div>
          </div>
        </ng-container>
      </div>
      <div *ngIf="!isAccessTokenPage || withAccessTokenWorkers" class="statistics-info__block stat dashboard-card d-card-padding" [class.wm-loading]="!initStatisticsLoaded">
        <ng-container *ngIf="initStatisticsLoaded">
          <h3 class="stat__title bold mb-1">
            {{ 'WM_TECH_POOL.STATISTICS.HASHRATE' | translate }}
          </h3>

          <div class="stat__main">
            <span class="stat__subtitle opacity-text mat-small">{{ 'STATISTICS.10MIN_AVG' | translate }}</span>
            <p>
              <ng-container *ngIf="!isAccessTokenPage">
                <span class="stat__value mat-h1">{{ selectedFarm?.summary?.hashrate }}{{ selectedFarm?.summary?.hashrateSymbol }}</span>
              </ng-container>

              <ng-container *ngIf="isAccessTokenPage">
                <span class="stat__value mat-h1">{{ workersSummary?.summary?.hashrate }}{{ workersSummary?.summary?.hashrateSymbol }}</span>
              </ng-container>
            </p>
          </div>

          <div class="stat__total-block total">
            <div class="total">
              <p class="opacity-text">
                <ng-container *ngIf="!isAccessTokenPage">
                  <span>{{ selectedFarm?.summary?.hashrate1h }}</span
                  >&nbsp;{{ selectedFarm?.summary?.hashrate1hSymbol }}
                </ng-container>

                <ng-container *ngIf="isAccessTokenPage">
                  <span>{{ workersSummary?.summary?.hashrate1h }}</span
                  >&nbsp;{{ workersSummary?.summary?.hashrate1hSymbol }}
                </ng-container>
              </p>
              <div class="total-gradient"></div>
              <p class="opacity-text mat-small">
                {{ 'WM_TECH_POOL.STATISTICS.1H_AVG' | translate }}
              </p>
            </div>

            <div class="total">
              <p class="opacity-text">
                <ng-container *ngIf="!isAccessTokenPage">
                  <span>{{ selectedFarm?.summary?.hashrate24h }}</span
                  >&nbsp;{{ selectedFarm?.summary?.hashrate24hSymbol }}
                </ng-container>

                <ng-container *ngIf="isAccessTokenPage">
                  <span>{{ workersSummary?.summary?.hashrate24h }}</span
                  >&nbsp;{{ workersSummary?.summary?.hashrate24hSymbol }}
                </ng-container>
              </p>
              <div class="total-gradient"></div>
              <p class="opacity-text mat-small">
                {{ 'WM_TECH_POOL.STATISTICS.1DAY_AVG' | translate }}
              </p>
            </div>
          </div>
        </ng-container>
      </div>
      <div *ngIf="!isAccessTokenPage || withAccessTokenWorkers" class="statistics-info__block stat dashboard-card d-card-padding" [class.wm-loading]="!initStatisticsLoaded">
        <ng-container *ngIf="initStatisticsLoaded">
          <h3 class="stat__title bold">
            {{ 'WM_TECH_POOL.STATISTICS.WORKER' | translate }}
          </h3>

          <div class="stat__workers">
            <wm-libs-workers-stats-chart [workers]="initWorkers" app="wm-tech-pool"></wm-libs-workers-stats-chart>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <ng-container *ngIf="initStatisticsLoaded === true; else initStatisticsLoading">
    <ng-container *ngIf="initStatistics?.hashrateHistories?.length || initWorkers?.count; else emptyStatistics">
      <div class="dashboard-card d-card-padding">
        <div class="chart-header">
          <h4 class="bold">{{ 'WM_TECH_POOL.STATISTICS.CHART.TITLE' | translate }}</h4>
          <div class="chart-buttons">
            <mat-button-toggle-group class="flex" appearance="legacy" #group="matButtonToggleGroup" hideSingleSelectionIndicator="true" value="10min" (change)="selectPeriod(group.value)">
              <mat-button-toggle value="10min" class="flex border borderBtnPool">{{ 'WM_TECH_POOL.STATISTICS.CHART.10MIN' | translate }}</mat-button-toggle>
              <mat-button-toggle value="1hour" class="flex border borderBtnPool">{{ 'WM_TECH_POOL.STATISTICS.CHART.1HOUR' | translate }}</mat-button-toggle>
              <mat-button-toggle value="daily" class="flex border borderBtnPool">{{ 'WM_TECH_POOL.STATISTICS.CHART.DAILY' | translate }}</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
        <ng-container *ngIf="statisticsLoaded === true; else statisticsLoading">
          <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" style="width: 100%; height: 400px; display: block"> </highcharts-chart>
          <div *ngIf="!statistics?.hashrateHistories?.length && initWorkers?.count" class="empty-statistcs-title opacity-text italic">
            {{ 'WM_TECH_POOL.STATISTICS.CHART.EMPTY' | translate }}
          </div>
        </ng-container>
      </div>
      <app-workers *ngIf="!isAccessTokenPage" [isStatisticsPage]="true"></app-workers>
    </ng-container>
  </ng-container>
</div>

<ng-template #initStatisticsLoading>
  <div class="dashboard-card wm-loading" style="height: 475px"></div>
</ng-template>
<ng-template #statisticsLoading>
  <div class="dashboard-card wm-loading" style="height: 400px; margin: 0"></div>
</ng-template>
<ng-template #emptyStatistics>
  <div class="dashboard-card d-card-padding">
    <app-empty-data [data]="'statistics'"></app-empty-data>
  </div>
</ng-template>
